@if (showBetNowEpcotNotification && isRewardDrawerEnabled) {
    <ms-epcot-notification [message]="rewardsToastMessage" [showCloseButton]="true" (closeButtonClick)="hideToaster()" />
}
<div class="reward-tokens-container">
    <div class="reward-tokens-card__icon-container" [ngClass]="{ 'reward-tokens-card__icon-container-new-reward-drawer': isRewardDrawerEnabled }">
        @if (isRewardDrawerEnabled && iconUrl) {
            <div class="crm-token-image-card">
                @if (tokenSelected()) {
                    <i class="theme-success-i"></i>
                } @else {
                    <img class="crm-token-image-card-circle" [src]="iconUrl" [ngClass]="iconClasses" />
                }
            </div>
        } @else {
            <div class="reward-tokens-card__icon" [ngClass]="iconClasses"></div>
        }
    </div>
    <div class="reward-tokens-card__token-container">
        @let token = tokenInfo.token;
        @if (isTokenType(token, 'AccaBoost')) {
            <bs-acca-boost-card [token]="token" [isRewardBannerView]="isRewardBannerView" [isRewardDrawerEnabled]="isRewardDrawerEnabled" />
        } @else if (isTokenType(token, 'OddsBoost')) {
            <bs-odds-boost-card
                [token]="token"
                [tokenContext]="tokenContext"
                [isRewardBannerView]="isRewardBannerView"
                [isRewardDrawerEnabled]="isRewardDrawerEnabled"
                [isTokenSelected]="tokenInfo.selected"
                [vipBadgeTemplate]="isVipExclusive ? vipBadgeTemplate : undefined" />
        } @else if (isTokenType(token, 'FreeBet')) {
            <bs-freebet-card
                [token]="token"
                [isRewardBannerView]="isRewardBannerView"
                [isRewardDrawerEnabled]="isRewardDrawerEnabled"
                [isTokenSelected]="tokenInfo.selected"
                [vipBadgeTemplate]="isVipExclusive ? vipBadgeTemplate : undefined" />
        } @else if (isTokenType(token, 'RiskFreeBet')) {
            <bs-risk-free-card
                [token]="token"
                [isRewardBannerView]="isRewardBannerView"
                [isRewardDrawerEnabled]="isRewardDrawerEnabled"
                [isTokenSelected]="tokenInfo.selected"
                [vipBadgeTemplate]="isVipExclusive ? vipBadgeTemplate : undefined" />
        } @else if (isTokenType(token, 'BetAndGet')) {
            <bs-betandget-card
                [token]="token"
                [isRewardBannerView]="isRewardBannerView"
                [isRewardDrawerEnabled]="isRewardDrawerEnabled"
                [isTokenSelected]="tokenInfo.selected"
                [vipBadgeTemplate]="isVipExclusive ? vipBadgeTemplate : undefined" />
        }
    </div>
    <ng-template #vipBadgeTemplate>
        <vn-icon class="badge-vip" [name]="sitecore.crmTokens.messages.VIPBadgeIcon" [size]="sitecore.crmTokens.messages.VIPBadgeIconSize" />
    </ng-template>
</div>
